// extracted by mini-css-extract-plugin
module.exports = {"section":"Section_section__hnWAR","childWrapper":"Section_childWrapper__rIGtj","navigationButton":"Section_navigationButton__5Ek7U"};